import {authRedirectUrl, clearAuthenticatedCache, getCurrentStaff, hasLoggedOutSsoToken} from '~/middleware/authenticated';

/**
 * ログアウト直後のブラウザ「戻る」操作で bfcache（Back/Forward Cache）から
 * ログイン中の旧画面がそのまま復元されて操作できてしまう問題を防ぐ。
 *
 * pageshow / visibilitychange で現在の認証状態を再確認し、
 * ログアウト済みならログイン画面へリダイレクトする。
 * bfcache 復元時は認証ミドルウェアが再実行されないため、ここで直接制御する。
 *
 * SSO コールバック URL は authenticated middleware 側で処理するためここでは触らない。
 */
export default ({store, app, route}) => {
  if (!process.client) return;

  const excludeRouteNameList = ['property-property', 'privacy', 'message-line-registration', 'line-tracking'];
  const currentRoute = () => app?.router?.currentRoute || route;
  const isExcludedRoute = () => {
    return excludeRouteNameList.some(routeName => currentRoute().name?.includes(routeName));
  }
  let isChecking = false;
  let isRedirecting = false;

  const redirectToAuth = () => {
    if (isRedirecting) return;

    isRedirecting = true;
    clearAuthenticatedCache(store);
    window.location.replace(authRedirectUrl(app?.router?.currentRoute || route));
  }

  const revalidateAuth = async () => {
    if (isExcludedRoute() || isChecking || isRedirecting) return;

    if (hasLoggedOutSsoToken()) {
      redirectToAuth();
      return;
    }

    isChecking = true;
    const staff = await getCurrentStaff({store, force: true});
    isChecking = false;
    if (!staff) redirectToAuth();
  }

  window.addEventListener('pageshow', revalidateAuth);
  document.addEventListener('visibilitychange', () => {
    if (document.visibilityState === 'visible') revalidateAuth();
  });
};
